<template lang="pug">
  ValidationProvider.pho-validation-provider(
    v-slot="{ errors }"
    v-bind="$attrs"
    ref="validationProvider"
    :name="name"
    :rules="rules"
  )
    slot
    slot(name="errors" v-if="isErrorAvailable(errors)" :errors="errors")
      .v-messages.theme--light.error--text(role="alert")
        .v-messages__wrapper
          .v-messages__message(v-for="(error, index) in errors" :key="index") {{ error }}
</template>

<script>
import { useContext } from '@/compat';
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'PhoValidationProvider',
  components: {
    ValidationProvider,
  },
  props: {
    rules: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  emits: ['onValidationFailed'],
  setup(_, { emit }) {
    const { $refs } = useContext();

    const isErrorAvailable = errors => {
      if (errors.length > 0) {
        emit('onValidationFailed', errors);
      }

      return errors.length > 0;
    };

    const validate = () => {
      $refs.validationProvider.validate();
    };

    return {
      isErrorAvailable,
      validate,
    };
  },
};
</script>
